import React from 'react'
import { CreditApplication } from '_gql'

import { useMakeTestId } from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import { StatusButtons } from '@sputnik/components'
import ImageWrapper from '@sputnik/components/ImageWrapper/ImageWrapper'
import StatusTile from '@sputnik/pages/Dashboard/StatusTile/StatusTile'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'

interface MajorAccountChangeStatusTileProps {
  creditApp: CreditApplication
}

// This status shows if recordType is 'major_account_change' is not_started, in_progress, awaiting_signature, or correction_requested status
const MajorAccountChangeStatusTile = ({ creditApp }: MajorAccountChangeStatusTileProps) => {
  const makeTestId = useMakeTestId('MajorAccountChangeStatusTile')
  const { salesforceCreditId, lastUpdatedByApplicantAt } = creditApp || {}

  return (
    <div data-testid={makeTestId('')}>
      <StatusTile
        creditApp={creditApp}
        image={
          <ImageWrapper
            alt='buildings'
            imageName='dashboard-application-major-account-change'
          />
        }
        primaryInfo={
          <FormattedMessage
            defaultMessage='Updated account information needed.'
            id='sputnik.MajorAccountChangeStatusTile__DWIbf3'
          />
        }
        secondaryInfo={
          <FormattedMessage
            defaultMessage='Last updated on {date, date, long}'
            id='sputnik.MajorAccountChangeStatusTile__jQ4xa+'
            values={{ date: new Date(lastUpdatedByApplicantAt) }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Major account update'
            id='sputnik.MajorAccountChangeStatusTile__nRhzRG'
          />
        }
      >
        <StatusButtons
          hideSecondary
          primaryPath={`/app/${salesforceCreditId}/${PATHNAME_CONSTS.REVIEW_PATH}`}
          primaryText={
            <FormattedMessage
              defaultMessage='Update my account changes'
              id='sputnik.MajorAccountChangeStatusTile__69Z0lm'
            />
          }
        />
      </StatusTile>
    </div>
  )
}

export default MajorAccountChangeStatusTile
